import api from "./ApiURLBase";
const EndPointGetDepartments = async (miningSite, nameFilter, idFilter) =>
  await api.get(`/departments/GetDepartments?miningSiteId=${miningSite}&nameFilter=${nameFilter}&idFilter=${idFilter}`);
const EndPointGetDepartmentID = async (id, name) =>
  await api.get(
    `/departments/GetDepartments?departmentId=${id}&departmentDescription=${name}`
  );
const EndPointDeleteDepartment = async (id, miningSite) =>
  await api.delete(`/departments/DeleteDepartment/${id}/${miningSite}`);
const EndPointCreateUpdateDepartment = async data =>
  await api.post(`/departments/CreateUpdateDepartment/`, data);

export {
  EndPointGetDepartments,
  EndPointDeleteDepartment,
  EndPointGetDepartmentID,
  EndPointCreateUpdateDepartment
};
